import { TaggingValidator } from './typings';

export const isRequired: TaggingValidator = (value) => value != null;

export const isNotEmpty: TaggingValidator = (value) => String(value).trim() !== '';
